import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';
import React, { useState } from 'react';
import { Download as ExportIcon } from 'react-feather';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CustomButton from 'src/components/common/customButton';
import CashlessFullDetails from './CashlessFullDetails';
import { SingleActionContent } from './CashlessActionDialog';
import { contractNameMapper } from './CashlesInfoText';

const CashlessResults = ({
  onPaginationChange,
  totalRequestCount,
  selectedRequests,
  setRequestSelection,
  selectAll,
  setSelectAll,
  setSingleRequest,
  exportFile,
  displayRequests,
  downloadResults,
  activeTable,
  actionDialogOpened,
  actionDialogOpenHandler,
  page,
  limit,
  setPage,
  setLimit,
  ...props
}) => {
  /* const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0); */
  const [exportType, setExportType] = useState('xlsx');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
    if (activeTable == 1) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('limit', event.target.value, activeTable);
    }
  };

  const setActiveTable = (value) => {
    setLimit(5);
    setPage(0);
    props.setActiveTable(value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (activeTable == 1) {
      onPaginationChange('page', newPage, activeTable);
    }
    if (activeTable == 0) {
      onPaginationChange('page', newPage, activeTable);
    }
  };

  const handleSelectAllClicked = (event) => {
    setSelectAll(!selectAll);
    Object.keys(selectedRequests).forEach((request) => {
      selectedRequests[request] = !selectAll;
    });
    setRequestSelection(selectedRequests);
  };

  const handleRequestSelectClikced = (requestid) => {
    selectedRequests[requestid] = !selectedRequests[requestid];
    setRequestSelection(selectedRequests);
    if (!selectedRequests[requestid]) {
      setSelectAll(false);
    }
  };

  return (
    <>
      <Grid container>
        <Grid xs={12} justifyContent="space-between" container item>
          <Grid
            item
            container
            sx={{
              borderRadius: 3,
              border: '1px solid #1778f2',
              width: '302px',
              height: '40px'
            }}
          >
            <CustomButton
              loading={props.loading.cashlessRequests}
              onClick={() => setActiveTable(1)}
              fontSize={12}
              shadow="false"
              active={activeTable == 1}
              title="Action Pending"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }}
            />
            <CustomButton
              loading={props.loading.cashlessRequests}
              onClick={() => setActiveTable(0)}
              fontSize={12}
              shadow="false"
              active={activeTable == 0}
              title="Frozen"
              sx={{
                borderRadius: 2,
                height: '100%',
                width: '150px'
              }}
            />
          </Grid>
          <Grid
            item
            container
            sx={{
              width: '180px'
            }}
          >
            <ButtonGroup
              variant="text"
              disabled={false}
              sx={{ boxShadow: '0 0 4px rgba(0,0,0,0.20)', borderRadius: 15 }}
            >
              <Button
                sx={{ px: 2 }}
                onClick={() => {
                  downloadResults();
                }}
                disabled={displayRequests.length == 0}
                startIcon={<ExportIcon size="18" />}
              >
                Export
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
        {displayRequests && displayRequests.length > 0 ? (
          <Grid xs item>
            <Card
              elevation={0}
              sx={{
                mt: 2
              }}
            >
              <PerfectScrollbar>
                <Box sx={{ minWidth: 1200 }}>
                  <TableContainer sx={{ maxHeight: 500 }}>
                    <Table
                      stickyHeader
                      aria-label="Cashless List"
                      id="Cashless-List"
                    >
                      <TableHead>
                        <TableRow>
                          {activeTable == 1 ? (
                            <TableCell padding="checkbox">
                              <div style={{ display: 'flex' }}>
                                <Checkbox
                                  sx={{
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 18
                                    }
                                  }}
                                  color="primary"
                                  checked={selectAll}
                                  onClick={handleSelectAllClicked}
                                />
                                <span
                                  style={{
                                    padding: 'auto',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    flexDirection: 'column'
                                  }}
                                >
                                  SelectAll
                                </span>
                              </div>
                            </TableCell>
                          ) : null}
                          <TableCell style={{ textAlign: 'center' }}>
                            Actions
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            OrderId
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            UserName
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            Cashless Amount
                          </TableCell>
                          {/* <TableCell style={{'textAlign' : 'center'}}>Service</TableCell> */}
                          <TableCell style={{ textAlign: 'center' }}>
                            OrderItems
                          </TableCell>
                          {/* <TableCell style={{'textAlign' : 'center'}}>Total PG Amount</TableCell>
                        <TableCell style={{'textAlign' : 'center'}}>Total Cart Amount</TableCell> */}
                          <TableCell style={{ textAlign: 'center' }}>
                            Service
                          </TableCell>
                          {activeTable == 0 ? (
                            <TableCell style={{ textAlign: 'center' }}>
                              Status
                            </TableCell>
                          ) : null}
                          <TableCell style={{ textAlign: 'center' }}>
                            Fulfilled On
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            CorporateName
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {displayRequests.map((order, idx) => (
                          <TableRow hover key={idx}>
                            {activeTable == 1 ? (
                              <TableCell padding="checkbox">
                                <Checkbox
                                  color="primary"
                                  sx={{
                                    '& .MuiSvgIcon-root': {
                                      fontSize: 18
                                    }
                                  }}
                                  checked={
                                    selectedRequests[order.requestid.toString()]
                                  }
                                  onClick={(e) => {
                                    handleRequestSelectClikced(
                                      order.requestid.toString()
                                    );
                                  }}
                                  value="true"
                                />
                              </TableCell>
                            ) : null}
                            <TableCell style={{ textAlign: 'center' }}>
                              <CashlessFullDetails requestFullDetails={order} />
                              {activeTable == 1 ? (
                                <>
                                  <Button
                                    variant="contained"
                                    style={{
                                      width: '100%',
                                      textAlgin: 'center',
                                      fontSize: '12px'
                                    }}
                                    disabled={actionDialogOpened}
                                    onClick={(e) => {
                                      setSingleRequest(order.requestid);
                                      actionDialogOpenHandler(
                                        <SingleActionContent
                                          RequestDetails={order}
                                        />,
                                        'Confirm Claim Approval',
                                        false
                                      );
                                    }}
                                  >
                                    Approve
                                  </Button>
                                  <Button
                                    variant="contained"
                                    style={{
                                      width: '100%',
                                      textAlgin: 'center',
                                      marginTop: '5px',
                                      fontSize: '12px'
                                    }}
                                    disabled={actionDialogOpened}
                                    onClick={(e) => {
                                      setSingleRequest(order.requestid);
                                      actionDialogOpenHandler(
                                        <SingleActionContent
                                          RequestDetails={order}
                                        />,
                                        'Confirm Claim Rejection',
                                        true
                                      );
                                    }}
                                  >
                                    Reject
                                  </Button>{' '}
                                </>
                              ) : null}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              {order.orderid ? order.orderid : null}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              {order.name ? order.name : null}
                            </TableCell>
                            {/* <TableCell style={{'textAlign' : 'center'}}>
                            {order.service_type ? order.service_type : null}
                          </TableCell> */}
                            <TableCell
                              style={{
                                textAlign: 'center',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              {order.total_cashless_amount
                                ? '₹ ' +
                                  order.total_cashless_amount.toString() +
                                  '/-'
                                : '₹ ' + '0' + '/-'}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              {order.cart_items ? order.cart_items : null}
                            </TableCell>
                            {/* <TableCell style={{'textAlign' : 'center'}}>
                            {order.total_pg_amount ? order.total_pg_amount : 0}
                          </TableCell>
                          <TableCell style={{'textAlign' : 'center'}}>
                            {order.total_amount ? order.total_amount : 0}
                          </TableCell> */}
                            <TableCell style={{ textAlign: 'center' }}>
                              {order.service_type
                                ? contractNameMapper(
                                    order.service_type,
                                    'Miscellaneous'
                                  )
                                : null}
                            </TableCell>
                            {activeTable == 0 ? (
                              <TableCell style={{ textAlign: 'center' }}>
                                {order.status ? order.status : null}
                              </TableCell>
                            ) : null}
                            <TableCell style={{ textAlign: 'center' }}>
                              {order.fullfilledon
                                ? new Date(order.fullfilledon).toUTCString()
                                : null}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              {order.corporate_name
                                ? order.corporate_name
                                : null}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </PerfectScrollbar>
              <TablePagination
                component="div"
                count={totalRequestCount}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page}
                rowsPerPage={limit}
                rowsPerPageOptions={[5, 10, 25]}
              />
            </Card>
          </Grid>
        ) : (
          <Grid container>
            <Grid xs={12} style={{ paddingTop: '20px' }}>
              <p style={{ color: '#212529', textAlign: 'center' }}>
                <strong>{'Sorry, no orders match your search criteria'}</strong>
              </p>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default CashlessResults;
